import styled from 'styled-components';
import { token } from '@bynder/design-system';

// Carries `zoom-control-wrapper`, whose height the timeline resize logic reads.
export const ZoomControlWrapper = styled.div`
    position: relative;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    width: auto;
    max-width: 100%;
    margin-bottom: 1px;
`;

export const ControlsRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ControlsGroup = styled.div`
    display: flex;
    align-items: center;
`;

export const SizeLabel = styled.div`
    display: flex;
    align-items: center;
    color: #809199;

    svg {
        margin-right: 9px;
        color: ${token.gray600};
    }
`;

export const DurationLabel = styled.small`
    margin: 0 10px;
    font-size: 0.875em;
    font-weight: 400;
`;
